import React, { useState, useCallback } from 'react';
import { Button } from 'primereact/button';
import DealerStockAddFilters from './components/DealerStockAddFilters';
import DealerStockAddTable from './components/DealerStockAddTable';
import AddStockDialog from './components/AddStockDialog';
import useDealerStockAddData from './hooks/useDealerStockAddData';
import { useLanguage } from '../../../contexts/LanguageContext';

const DealerStockAddPage = () => {
    const { th } = useLanguage();
    const {
        rows,
        loading,
        totalCount,
        pagination,
        onPageChange,
        filters,
        handleApplyFilters,
        handleResetFilters,
        refetch
    } = useDealerStockAddData();

    const [dialogVisible, setDialogVisible] = useState(false);

    const handleAddClick = useCallback(() => {
        setDialogVisible(true);
    }, []);

    const handleDialogHide = useCallback(() => {
        setDialogVisible(false);
    }, []);

    const handleAddSuccess = useCallback(() => {
        refetch();
    }, [refetch]);

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('dealerStockAdd.pageTitle')}</h1>
                <Button
                    label={th('common.add')}
                    icon="pi pi-plus"
                    className="p-button-success"
                    onClick={handleAddClick}
                />
            </div>

            <div className="mb-2">
                <DealerStockAddFilters
                    filters={filters}
                    onApplyFilters={handleApplyFilters}
                    onReset={handleResetFilters}
                />
            </div>

            <DealerStockAddTable
                rows={rows}
                loading={loading}
                totalCount={totalCount}
                pagination={pagination}
                onPageChange={onPageChange}
            />

            <AddStockDialog
                visible={dialogVisible}
                onHide={handleDialogHide}
                onSuccess={handleAddSuccess}
            />
        </div>
    );
};

export default DealerStockAddPage;
